import LiveBoardHomepageFirstFoldConfig from "./live-board-homepage-first-fold-config";
import LiveBoardHomepageFirstFoldAdvancedConfig from "./live-board-homepage-first-fold-advanced-config";
import dynamic from "next/dynamic";

const LiveBoardHomepageFirstFoldComponent = dynamic(() => import("./live-board-homepage-first-fold-component"));

export default {
  LiveBoardHomepageFirstFoldComponent,
  LiveBoardHomepageFirstFoldConfig,
  LiveBoardHomepageFirstFoldAdvancedConfig
};
